/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import IntentionTypes from '../../constants/intentionTypes';
import { scrumSprint } from '../../utils/taskHelpers';
import CustomSelect from '../Common/CustomSelect/SelectField';

/* eslint-disable jsx-a11y/label-has-associated-control */

const TASK_TYPES = [
  'Analysis',
  'Design',
  'Fixing',
  'Coding',
  'Test Analysis',
  'Testing',
  'Deployment Planning',
  'Deploying'
];
const GETTING_READY_TYPES = ['Analysis', 'Design'];
const IN_PROGRESS_TYPES = ['Fixing', 'Coding'];
const COMPLETED_TYPES = ['Test Analysis', 'Testing'];
const ACCEPTED_TYPES = ['Deployment Planning'];
const SHIPPABLE_TYPES = ['Deploying'];

class TaskType extends React.Component {
  constructor(props) {
    super(props);
    let { intention } = props;
    if (!intention) {
      if (props.intention && props.intention.length > 0) {
        [intention] = props.intentionOptions;
      } else {
        intention = IntentionTypes.GETTING_READY;
      }
    }

    this.state = {
      intention,
      kind: props.kind
    };

    this.allowedOptions = this.allowedOptions.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  allowedOptions() {
    const { parent = {}, isKanban, isNew, teamMemberWall } = this.props;
    const { state } = parent;

    const completedStates = [
      WorkPackageStatuses.COMPLETED,
      WorkPackageStatuses.ACCEPTED,
      WorkPackageStatuses.SHIPPABLE
    ].includes(parent.state);

    if (teamMemberWall) {
      return IN_PROGRESS_TYPES
    }

    if (isNew && isEmpty(parent)) {
      return TASK_TYPES;
    }

    switch (state) {
      case 'Getting Ready':
        return GETTING_READY_TYPES;
      case 'Ready':
      case 'In Progress':
        return IN_PROGRESS_TYPES;
      case 'Completed':
        return COMPLETED_TYPES;
      case 'Accepted':
        return ACCEPTED_TYPES;
      case 'Shippable':
        return SHIPPABLE_TYPES;
      default:
        return [];
    }
  }

  generateTypeOptions = () => {
    return this.allowedOptions().map((option) => {
      let taskState;
      if (GETTING_READY_TYPES.includes(option)) taskState = 'Getting Ready';
      else if (IN_PROGRESS_TYPES.includes(option)) taskState = 'In Progress';
      else if (COMPLETED_TYPES.includes(option)) taskState = 'Completed';
      else if (ACCEPTED_TYPES.includes(option)) taskState = 'Accepted';
      else if (SHIPPABLE_TYPES.includes(option)) taskState = 'Shippable';

      return {
        label: option,
        value: {
          name: option,
          state: taskState
        }
      };
    });
  };

  handleSelect(option) {
    const { kind, intention } = this.state;
    const taskTypePayload = {
      task_type: {
        intention,
        kind
      },
      state: option.value.state
    };

    taskTypePayload.task_type.kind = option.value.name;
    this.setState({
      intention: taskTypePayload.task_type.intention,
      kind: taskTypePayload.task_type.kind
    });
    return taskTypePayload;
  }

  render() {
    const { onFieldChange, disabled } = this.props;
    const { kind } = this.state;
    const typeOptions = this.generateTypeOptions();
    return (
      <div>
        {!this.props.split && <br />}
        <div
          className={this.props.split ? 'col-md-offset-2 col-md-5' : undefined}
        >
          <label>Type</label>
          <CustomSelect
            handleOptionChange={option =>
              onFieldChange(this.handleSelect(option))
            }
            options={typeOptions}
            selectedOption={{ label: kind, value: kind }}
            disabled={disabled}
          />
        </div>
      </div>
    );
  }
}

TaskType.propTypes = {
  type: PropTypes.string,
  intention: PropTypes.string,
  onFieldChange: PropTypes.func,
  disabled: PropTypes.bool,
  split: PropTypes.bool,
  isNew: PropTypes.bool
};

export default withRouter(TaskType);
